<template>
  <v-row dense class="justify-center">
    <!-- Startdatum -->
    <v-col cols="auto">
      <v-text-field
        class="txtStartDate"
        v-model="dateRangeFormatted.start"
        append-inner-icon="mdi-calendar"
        @click:append-inner="openDialogStart"
        density="compact"
        label="Beginn:"
        variant="solo"
        hide-details
        readonly
      />
    </v-col>
    <!-- Standort -->
    <v-col cols="auto">
      <DropDownLocation
        v-model="selectedLocation"
        :dropDownLocations="dateLocationMenuLocations"
      />
    </v-col>
    <!-- Enddatum -->
    <v-col cols="auto">
      <v-text-field
        class="txtEndDate"
        v-model="dateRangeFormatted.end"
        append-inner-icon="mdi-calendar"
        @click:append-inner="openDialogEnd"
        density="compact"
        label="Ende:"
        variant="solo"
        hide-details
        readonly
      />
    </v-col>
  </v-row>
  <!-- Dialog für Startdatum -->
  <v-dialog v-model="dialogStart" max-width="400" :fullscreen="$vuetify.display.smAndDown">
    <v-card>
      <v-card-text>
        <DatePicker v-model="dateRangePicker.start" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="elevated" color="primary" @click="confirmDateStart">OK</v-btn>
        <v-btn variant="elevated" color="grey" @click="dialogStart = false">Abbrechen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- Dialog für Enddatum -->
  <v-dialog v-model="dialogEnd" max-width="400" :fullscreen="$vuetify.display.smAndDown">
    <v-card>
      <v-card-text>
        <DatePicker v-model="dateRangePicker.end" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="elevated" color="primary" @click="confirmDateEnd">OK</v-btn>
        <v-btn variant="elevated" color="grey" @click="dialogEnd = false">Abbrechen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

import DatePicker from '../consumables/DatePicker.vue';
import DropDownLocation from '../consumables/DropDownLocation.vue';

export default {
  components: {
    DatePicker,
    DropDownLocation
  },

  props: {
    modelValue: {type: Object, required: true, default: () => ({ start: '', end: '' })},
    modelLocation: {type: String, default: ''},
    dateLocationMenuLocations: {type: Object, default: null},
  },

  emits: ['update:modelValue', 'update:modelLocation'],

  data() {
    return {
      selectedLocation: '',
      dialogStart: false,
      dialogEnd: false,
      dateRange: { start: '', end: '' },
      dateRangePicker: { start: '', end: '' },
      dateRangeFormatted: { start: '', end: '' }
    }
  },

  watch: {
    modelValue: {
      handler(newVal) {
        this.setDatesFromProp(newVal)
      },
      deep: true,
      immediate: true,
    },
    selectedLocation(val) {
      this.$emit('update:modelLocation', val)
    },
  },

  methods: {
    setDatesFromProp(val) {
      this.dateRange.start = val.start || this.getTomorrow()
      this.dateRange.end = val.end || this.getTomorrow()

      this.dateRangePicker.start = this.formatToDDMMYYYY(this.dateRange.start)
      this.dateRangePicker.end = this.formatToDDMMYYYY(this.dateRange.end)

      this.dateRangeFormatted.start = this.dateRangePicker.start
      this.dateRangeFormatted.end = this.dateRangePicker.end
    },

    openDialogStart() {
      this.dateRangePicker.start = this.dateRangeFormatted.start
      this.dialogStart = true
    },

    openDialogEnd() {
      this.dateRangePicker.end = this.dateRangeFormatted.end
      this.dialogEnd = true
    },

    confirmDateStart() {
      if (!this.dateRangePicker.start) return
      this.dateRange.start = this.parseDDMMYYYY(this.dateRangePicker.start)

      if (this.dateRange.start > this.dateRange.end) {
        this.dateRange.end = this.dateRange.start
        this.dateRangeFormatted.end = this.dateRangePicker.start
      }

      this.dateRangeFormatted.start = this.dateRangePicker.start
      this.emitUpdate()
      this.dialogStart = false
    },

    confirmDateEnd() {
      if (!this.dateRangePicker.end) return
      this.dateRange.end = this.parseDDMMYYYY(this.dateRangePicker.end)

      if (this.dateRange.end < this.dateRange.start) {
        this.dateRange.start = this.dateRange.end
        this.dateRangeFormatted.start = this.dateRangePicker.end
      }

      this.dateRangeFormatted.end = this.dateRangePicker.end
      this.emitUpdate()
      this.dialogEnd = false
    },

    emitUpdate() {
      this.$emit('update:modelValue', { 
        start: this.dateRange.start, 
        end: this.dateRange.end 
      })
    },

    getTomorrow() {
      const today = new Date()
      const tomorrow = new Date(today)
      tomorrow.setDate(today.getDate() + 1)
      const tomorrowStr = tomorrow.toISOString().slice(0, 10)

      return tomorrowStr
    },

    formatToDDMMYYYY(dateStr) {
      if (!dateStr) return ''
      const [yyyy, mm, dd] = dateStr.split('-')
      return `${dd}.${mm}.${yyyy}`
    },

    parseDDMMYYYY(formatted) {
      const parts = formatted.split('.')
      if (parts.length !== 3) return ''
      const [dd, mm, yyyy] = parts
      return `${yyyy}-${mm}-${dd}`
    },
  }
}
</script>

<style scoped>
.txtStartDate, 
.txtEndDate {
  border-radius: 4px;
  box-shadow: 0px 6px 15px hsla(0, 0%, 0%, 0.5);
  width: auto;
  min-width: 15rem;
}
</style>
